import type { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { UserFullname } from '@r/components/user-fullname.tsx';

interface WithCreatedAt {
  createdAt?: string;
}

export const useHistoryColumns = <T extends WithCreatedAt>(): ColumnDef<T>[] => {
  const { t } = useTranslation();

  return [
    {
      accessorKey: 'property',
      header: t('label.history.property')
    },
    {
      accessorKey: 'previousValue',
      header: t('label.history.previous.value')
    },
    {
      accessorKey: 'newValue',
      header: t('label.history.new.value')
    },
    {
      id: 'madeByUser',
      accessorFn: (row) =>
        (row as unknown as { madeByUser?: { fullname?: string } }).madeByUser?.fullname ?? '',
      header: t('label.history.made.by.user'),
      cell: ({ row }) => {
        const u = (
          row.original as unknown as { madeByUser?: { fullname?: string; isDeleted?: boolean } }
        ).madeByUser;
        return <UserFullname fullname={u?.fullname ?? ''} isDeleted={u?.isDeleted} />;
      }
    },
    {
      accessorKey: 'createdAt',
      header: t('label.history.created.at'),
      cell: ({ row }) => {
        return row.original.createdAt ? new Date(row.original.createdAt).toLocaleDateString() : '';
      }
    }
  ];
};
